<template>
  <div id="staffTotal">
    <van-nav-bar
        title="数据展示"
        right-text="刷新"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <van-row type="flex" justify="center" style="margin-top: 30px" >
      <van-col span="20">
        <div style="height: 300px" ref="staff"></div>
      </van-col>
    </van-row>
  </div>
</template>
<script>

import * as echarts from 'echarts'
import {Toast} from "vant";
export default {
  data () {
    return {
      staffOption: {
        title: {
          text: new Date().getFullYear() + '年员工入职情况',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}人',
          textStyle: {
            fontWeight: 'bold'
          }
        },
        xAxis: {
          type: 'category',
          data: ['一季度', '二季度', '三季度', '四季度']
        },
        yAxis: {
          type: 'value',
          name: '人数'
        },
        series: [
          {
            data: [100, 200, 150, 50],
            type: 'line'
          },
          {
            data: [100, 200, 150, 50],
            type: 'bar'
          }
        ]
      },
    }
  },
  methods: {
    loading () {
      const staffChart = echarts.init(this.$refs.staff)
      staffChart.setOption(this.staffOption)
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.loading()
      Toast('已刷新');
    },
  },
  mounted() {
    this.loading()
  }
}
</script>
